// Form Validation and Spam Prevention
document.addEventListener("DOMContentLoaded", function () {
  // Spam patterns and offensive language lists
  const spammyEmailPatterns = [/@(.*\.)?(ru|xyz|top|info|buzz|vip|live|club|shop|gq|loan|download|win|date|online|click|stream)$/i];
  const allowedDomains = [/@(.*\.)?gmail\.com$/i, /@(.*\.)?yahoo\.com$/i];

  // Offensive word patterns
  const offensiveWords = [
    'f[!@#$%^&*]*u[!@#$%^&*]*c[!@#$%^&*]*k',
    's[!@#$%^&*]*h[!@#$%^&*]*i[!@#$%^&*]*t',
    'a[!@#$%^&*]*s[!@#$%^&*]*s',
    'b[!@#$%^&*]*i[!@#$%^&*]*t[!@#$%^&*]*c[!@#$%^&*]*h',
    'd[!@#$%^&*]*i[!@#$%^&*]*c[!@#$%^&*]*k',
    'p[!@#$%^&*]*i[!@#$%^&*]*s',
    'w[!@#$%^&*]*h[!@#$%^&*]*o[!@#$%^&*]*r[!@#$%^&*]*e',
    's[!@#$%^&*]*l[!@#$%^&*]*u[!@#$%^&*]*t',
    'c[!@#$%^&*]*u[!@#$%^&*]*n[!@#$%^&*]*t'
  ];

  // Create the offensive regex dynamically
  const offensiveRegex = new RegExp(`\\b(${offensiveWords.join('|')})\\b`, 'gi');
  const threateningPhrases = ["send this to me free or I might steal it", "give me free or else", "free or I will steal"];
  const allowedFreePhrases = ["free shipping", "free returns", "free gift"];

  // Date validation function
  function validateDateFields(form) {
    const dateErrors = [];
    const dateContainers = form.querySelectorAll('._dateFieldContainer_rzr7e_5');

    dateContainers.forEach(container => {
      const mmInput = container.querySelector('input[aria-labelledby="label-MM"]');
      const ddInput = container.querySelector('input[aria-labelledby="label-DD"]');
      const yyyyInput = container.querySelector('input[aria-labelledby="label-YYYY"]');

      const mm = mmInput.value.trim();
      const dd = ddInput.value.trim();
      const yyyy = yyyyInput.value.trim();

      if (mm && dd && yyyy) {
        if (isNaN(mm) || isNaN(dd) || isNaN(yyyy)) {
          dateErrors.push({ container, message: "Please enter valid numbers for date" });
          return;
        }

        const paddedMonth = mm.padStart(2, '0');
        const paddedDay = dd.padStart(2, '0');
        const dateStr = `${yyyy}-${paddedMonth}-${paddedDay}`;
        const inputDate = new Date(dateStr);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (isNaN(inputDate.getTime())) {
          dateErrors.push({ container, message: "Invalid date entered" });
        } else if (inputDate < today) {
          dateErrors.push({ container, message: "Date cannot be in the past" });
        }
      }
    });

    return dateErrors;
  }

  // Core form validation function
  function checkFields(form) {
    const submitButton = form.querySelector("button[type='submit']");
    const firstName = form.querySelector("#first_name");
    const lastName = form.querySelector("#last_name");
    const message = form.querySelector("textarea");
    const email = form.querySelector("#email");
    const hcaptchaResponse = form.querySelector("input[name='h-captcha-response']");

    // Spam checks
    const spammyFields = [
      { field: firstName, reason: getSpammyReason(firstName) },
      { field: lastName, reason: getSpammyReason(lastName) },
      { field: message, reason: getSpammyReason(message) },
      { field: email, reason: getSpammyReason(email) }
    ].filter(entry => entry.reason);

    // Validation states
    const isSpammy = spammyFields.length > 0;
    const isCaptchaValid = hcaptchaResponse?.value;
    const dateErrors = validateDateFields(form);

    // Update submit button
    submitButton.disabled = isSpammy || !isCaptchaValid || dateErrors.length > 0;

    // Show errors
    showErrorMessages(form, spammyFields, isCaptchaValid, dateErrors);
  }

  // Error message handling
  function showErrorMessages(form, spammyFields, isCaptchaValid, dateErrors = []) {
    // Clear existing errors
    form.querySelectorAll(".error-message").forEach(error => error.remove());

    // Spam errors
    spammyFields.forEach(({ field, reason }) => {
      const errorMessage = document.createElement("div");
      errorMessage.className = "error-message form-error";
      errorMessage.textContent = reason;
      field.parentNode.insertBefore(errorMessage, field.nextSibling);
    });

    // Date errors
    dateErrors.forEach(({ container, message }) => {
      const errorMessage = document.createElement("div");
      errorMessage.className = "error-message form-error";
      errorMessage.textContent = message;
      container.parentNode.insertBefore(errorMessage, container.nextSibling);
    });

    // hCaptcha error
    if (!isCaptchaValid) {
      const hcaptchaContainer = form.querySelector(".h-captcha");
      if (hcaptchaContainer) {
        const errorMessage = document.createElement("div");
        errorMessage.className = "error-message form-error";
        errorMessage.textContent = "Please complete the hCaptcha.";
        hcaptchaContainer.parentNode.insertBefore(errorMessage, hcaptchaContainer.nextSibling);
      }
    }
  }

  // Field monitoring
  function monitorFieldChanges(form) {
    const fields = form.querySelectorAll("#first_name, #last_name, textarea, #email, ._dateFieldContainer_rzr7e_5 input");
    fields.forEach(field => field.addEventListener("input", () => checkFields(form)));
  }

  // Helper functions
  function containsOffensiveLanguage(text) {
    if (!text) return false;
    const lowerText = text.toLowerCase();
    return offensiveRegex.test(lowerText) || 
          threateningPhrases.some(phrase => lowerText.includes(phrase));
  }

  function isAllowedFreePhrase(text) {
    if (!text) return false;
    const lowerText = text.toLowerCase();
    return allowedFreePhrases.some(phrase => lowerText.includes(phrase));
  }

  function getSpammyReason(field) {
    if (!field?.value) return null;
    const spamPattern = /free|winner|prize|click.*here|subscribe|buy.*now|limited.*time|urgent|act.*now|guaranteed|risk-free|promise|deal|discount/i;
    
    if (spamPattern.test(field.value) && !isAllowedFreePhrase(field.value)) {
      const match = field.value.match(spamPattern);
      return `Avoid spammy content like '${match[0]}'.`;
    }
    return containsOffensiveLanguage(field.value) ? "Avoid offensive language." : null;
  }

  // hCaptcha integration
  function addHcaptchaToForm(form) {
    if (form.querySelector(".h-captcha")) return;
    const hcaptchaSiteKey = window.themeSettings?.hcaptcha?.siteKey || "b35aa612-ba8a-4436-96dc-d64e60f0dfd0";
    const hcaptchaContainer = document.createElement("div");
    hcaptchaContainer.className = "h-captcha";
    hcaptchaContainer.setAttribute("data-sitekey", hcaptchaSiteKey);

    const submitButton = form.querySelector("button[type='submit']");
    submitButton ? form.insertBefore(hcaptchaContainer, submitButton) : form.appendChild(hcaptchaContainer);
    renderHcaptcha(form, hcaptchaContainer);
  }

  function renderHcaptcha(form, container) {
    if (window.hcaptcha) {
      const hcaptchaSiteKey = window.themeSettings?.hcaptcha?.siteKey || "b35aa612-ba8a-4436-96dc-d64e60f0dfd0";
      hcaptcha.render(container, {
        sitekey: hcaptchaSiteKey,
        callback: (token) => {
          let hcaptchaInput = form.querySelector("input[name='h-captcha-response']") || document.createElement("input");
          hcaptchaInput.type = "hidden";
          hcaptchaInput.name = "h-captcha-response";
          hcaptchaInput.value = token;
          if (!hcaptchaInput.parentNode) form.appendChild(hcaptchaInput);
          checkFields(form);
        }
      });
    } else {
      setTimeout(() => renderHcaptcha(form, container), 100);
    }
  }

  // Form initialization
  function enhanceForm(form) {
    addHcaptchaToForm(form);
    const submitButton = form.querySelector("button[type='submit']");
    submitButton.disabled = true;
    monitorFieldChanges(form);
    checkFields(form);
  }

  // Dynamic form handling
  const formObserver = new MutationObserver(mutations => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.shadowRoot) {
          const form = node.shadowRoot.querySelector("form");
          if (form) enhanceForm(form);

          // Inject CSS into shadow DOM for label positioning
          const style = document.createElement("style");
          style.textContent = `
            ._formFieldContainer_1ydxd_5 label {
              top: 1em !important;
            }
          `;
          node.shadowRoot.appendChild(style);
        }
      });
    });
  });

  formObserver.observe(document.body, { childList: true, subtree: true });

  // Initialize existing forms
  document.querySelectorAll("#form-container-ref").forEach(container => {
    if (container.shadowRoot) {
      const form = container.shadowRoot.querySelector("form");
      if (form) enhanceForm(form);

      // Inject CSS into shadow DOM for label positioning
      const style = document.createElement("style");
      style.textContent = `
        ._formFieldContainer_1ydxd_5 label {
          top: 1em !important;
        }
      `;
      container.shadowRoot.appendChild(style);
    }
  });
}); 